import styles from '@uuhsc/cores-app-library/styles/drawer.module.css';
import { OpenDetailsButton } from 'Components/Buttons';
import { SITE_PAGES } from 'Config';
import { getUserNameFromId, useDrawerContext } from 'Context';
import UserDetails from 'Pages/Admin/Users/UserDetails';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';
import { isItemInactive, isUserAuthorized } from 'Util';

const UserNameWithDrawerButton = ({
  userId,
  label,
  includeLinkToDetails = true,
  noWrapLabel = false,
  ...props
}) => {
  const navigate = useNavigate();
  const { openDrawer, closeDrawer } = useDrawerContext();

  const onClickForDetail = () => {
    closeDrawer();
    navigate(`${SITE_PAGES.MANAGE_USERS.path}/${userId}`);
  };

  let userName = getUserNameFromId(userId);
  let drawerTitle =
    includeLinkToDetails &&
    isUserAuthorized(SITE_PAGES.MANAGE_USERS.requiredAuth) ? (
      <>
        <span className={isItemInactive(userName) ? styles.inactive : ''}>
          {userName}
        </span>
        <OpenDetailsButton
          tooltipText='Click to manage user'
          onClick={onClickForDetail}
        />
      </>
    ) : (
      userName
    );

  let drawerContent = userId != null && (
    <UserDetails {...props} userId={userId} />
  );

  const onClick = () => {
    openDrawer({
      content: drawerContent,
      title: drawerTitle,
    });
  };

  return (
    (label || userName) && (
      <span
        className={`${noWrapLabel ? styles.no_wrap_drawer_button_text : ''} ${
          isItemInactive(userName) ? styles.inactive : ''
        }`}
        onClick={onClick}>
        {label || userName}
      </span>
    )
  );
};

UserNameWithDrawerButton.propTypes = {
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.object,
  includeLinkToDetails: PropTypes.bool,
  noWrapLabel: PropTypes.bool,
};

export default UserNameWithDrawerButton;
